module.exports = __webpack_public_path__ + "static/media/view-content-icon.a11903d5.png";